import Button from 'components/common/Button/Button'
import Modal, { ModalRef } from 'components/common/Modal/Modal'
import React, { forwardRef } from 'react'

type Props = {
  children: React.ReactChild | React.ReactChild[]
  onSuccess?: () => void
  onCancel?: () => void
  successButton?: React.ReactChild
}

const ConfirmationModal = forwardRef<ModalRef, Props>(
  ({ children, onSuccess, onCancel, successButton }, ref) => {
    return (
      <Modal ref={ref} className="p-12 h-auto w-full md:w-1/2">
        <div>{children}</div>

        <div className="flex space-x-4 mt-8">
          {successButton ?? (
            <Button onClick={onSuccess} variant="active" text="Confirm" />
          )}
          <Button onClick={onCancel} variant="danger" text="Cancel" />
        </div>
      </Modal>
    )
  }
)

export default ConfirmationModal
